import { useQuery } from "@tanstack/react-query"

import { getSampleApplicationStatus } from "@/api"

export const useQuerySampleStatus = (kolSubmissionId?: string) => {
  return useQuery({
    queryKey: ["sample-application-status", kolSubmissionId],
    enabled: !!kolSubmissionId,
    queryFn: () => getSampleApplicationStatus(kolSubmissionId as string),
    select: (data) => data?.data?.data?.isRequestRegisterSample ?? false,
    retry: false,
    staleTime: 30000
  })
}
